var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.53685 0.667969L5.99935 5.12075L10.4618 0.667969L11.8327 2.0388L5.99935 7.87214L0.166016 2.0388L1.53685 0.667969Z","fill":"#5E6A79"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }